export default __webpack_public_path__ + "static/media/star.ab56eb60.svg";